// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3Nxgq","insightsList":"newBusinessInsightsMenu_insightsList__1Udq_","active":"newBusinessInsightsMenu_active__1sLql"};